import { Boundaries } from "@planzone/core";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State } from "./types";
import { getZoneState } from "./utils";

function handleSuccess(
  state: State,
  data: Boundaries["retrieveZoneProjects"]["success"],
): State {
  const { index, result } = getZoneState(state, data);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...result,
          request: setRequestStateToSuccess(),
          projects:
            data.filter.start === 0
              ? data.projects
              : [...result.projects, ...data.projects],
          callCount: result.callCount + 1,
          canRetrieveNextProjects: data.projects.length >= data.filter.limit,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          ...result,
          callCount: 1,
          request: setRequestStateToSuccess(),
          projects: data.projects,
          canRetrieveNextProjects: data.projects.length <= data.filter.limit,
        },
      ];
}

export { handleSuccess };
